export const iconsData = [
  {
    name: "user",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z" />
      </svg>
    ),
  },

  {
    name: "eye",
    icon: (
      <svg viewBox="0 0 576 512">
        <path d="M288 80c-65 0-119 30-160 68-38 36-65 78-79 108 14 30 41 73 79 108 41 38 95 68 160 68s119-30 160-68c38-35 65-78 79-108-14-30-41-72-79-108-41-38-95-68-160-68zM95 113c48-44 112-81 193-81s146 37 193 81c46 43 78 95 93 131 3 8 3 16 0 24-15 36-47 88-93 131-47 44-112 81-193 81s-145-37-193-81c-46-43-78-95-92-131-4-8-4-16 0-24 14-36 46-88 92-131zm193 223a80 80 0 1 0 0-160h-2l2 16a64 64 0 0 1-80 62v2c0 44 36 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
      </svg>
    ),
  },

  {
    name: "eyeSlash",
    icon: (
      <svg viewBox="0 0 640 512">
        <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z" />
      </svg>
    ),
  },

  {
    name: "burgerMenu",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
      </svg>
    ),
  },

  {
    name: "chevronRight",
    icon: (
      <svg viewBox="0 0 320 512">
        <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
      </svg>
    ),
  },

  {
    name: "search",
    icon: (
      <svg viewBox="0 0 512 512">
        <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
      </svg>
    ),
  },

  {
    name: "xMark",
    icon: (
      <svg viewBox="0 0 384 512">
        <path d="M343 151a32 32 0 0 0-46-46L192 211 87 105a32 32 0 0 0-46 46l106 105L41 361a32 32 0 0 0 46 46l105-106 105 106a32 32 0 0 0 46-46L237 256l106-105z" />
      </svg>
    ),
  },

  {
    name: "email2",
    icon: (
      <svg fill="none" viewBox="0 0 22 16">
        <path stroke="#fff" d="m1 1 10 7 10-7M1 15h20V1H1v14Z" />
      </svg>
    ),
  },

  {
    name: "phone",
    icon: (
      <svg fill="none" viewBox="0 0 22 22">
        <path
          stroke="#fff"
          d="M9.554 5.24 6.171 1.335c-.39-.45-1.105-.448-1.558.006L1.831 4.128c-.828.829-1.065 2.06-.586 3.047a29.207 29.207 0 0 0 13.561 13.58c.986.479 2.216.242 3.044-.587l2.808-2.813c.455-.455.456-1.174.002-1.564l-3.92-3.365c-.41-.352-1.047-.306-1.458.106l-1.364 1.366a.462.462 0 0 1-.553.088 14.558 14.558 0 0 1-5.36-5.367.463.463 0 0 1 .088-.554l1.36-1.361c.412-.414.457-1.054.101-1.465v.001Z"
        />
      </svg>
    ),
  },

  {
    name: "checked",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M439 105c12 13 12 33 0 46L183 407a32 32 0 0 1-46 0L9 279a32 32 0 0 1 46-46l105 106 233-234c13-12 33-12 46 0z" />
      </svg>
    ),
  },

  {
    name: "star",
    icon: (
      <svg viewBox="0 0 576 512">
        <path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z" />
      </svg>
    ),
  },

  {
    name: "list",
    icon: (
      <svg viewBox="0 10 512 512">
        <path d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z" />
      </svg>
    ),
  },

  {
    name: "home",
    icon: (
      <svg viewBox="0 0 16 16">
        <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z" />
      </svg>
    ),
  },

  {
    name: "filePaper",
    icon: (
      <svg viewBox="0 0 384 512">
        <path d="M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z" />
      </svg>
    ),
  },

  {
    name: "bag",
    icon: (
      <svg viewBox="0 0 16 16">
        <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z" />
      </svg>
    ),
  },

  {
    name: "bell",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112v25.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V208c0-61.9 50.1-112 112-112zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z" />
      </svg>
    ),
  },

  {
    name: "boxArrowRight",
    icon: (
      <svg fill="currentColor" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
        />
        <path
          fillRule="evenodd"
          d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
        />
      </svg>
    ),
  },

  {
    name: "arrowRightLong",
    icon: (
      <svg viewBox="0 0 512 512">
        <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.4H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h370.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z" />
      </svg>
    ),
  },

  {
    name: "cart3",
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16">
        <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l.84 4.479 9.144-.459L13.89 4zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
      </svg>
    ),
  },

  {
    name: "gamepad",
    icon: (
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="transparent"
        data-stroke-hover
      >
        <g clipPath="url(#clip0_2587_809)">
          <path
            d="M46.6666 14H9.33329C6.75596 14 4.66663 16.0893 4.66663 18.6667V37.3333C4.66663 39.9107 6.75596 42 9.33329 42H46.6666C49.244 42 51.3333 39.9107 51.3333 37.3333V18.6667C51.3333 16.0893 49.244 14 46.6666 14Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14 28H23.3333M18.6667 23.3334V32.6667"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35 25.6666V25.6908"
            stroke="black"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42 30.3333V30.3574"
            stroke="black"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2587_809">
            <rect width="56" height="56" />
          </clipPath>
        </defs>
      </svg>
    ),
  },

  {
    name: "headphone",
    icon: (
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="transparent"
        data-stroke-hover
      >
        <g clipPath="url(#clip0_2587_644)">
          <path
            d="M16.3333 30.3334H14C11.4227 30.3334 9.33331 32.4227 9.33331 35V42C9.33331 44.5774 11.4227 46.6667 14 46.6667H16.3333C18.9106 46.6667 21 44.5774 21 42V35C21 32.4227 18.9106 30.3334 16.3333 30.3334Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42 30.3334H39.6667C37.0893 30.3334 35 32.4227 35 35V42C35 44.5774 37.0893 46.6667 39.6667 46.6667H42C44.5773 46.6667 46.6667 44.5774 46.6667 42V35C46.6667 32.4227 44.5773 30.3334 42 30.3334Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.33331 35V28C9.33331 23.0493 11.3 18.3014 14.8007 14.8007C18.3013 11.3 23.0493 9.33337 28 9.33337C32.9507 9.33337 37.6986 11.3 41.1993 14.8007C44.7 18.3014 46.6666 23.0493 46.6666 28V35"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2587_644">
            <rect width="56" height="56" />
          </clipPath>
        </defs>
      </svg>
    ),
  },

  {
    name: "smartWatch",
    icon: (
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="transparent"
        data-stroke-hover
      >
        <g clipPath="url(#clip0_2587_629)">
          <path
            d="M35 14H21C17.134 14 14 17.134 14 21V35C14 38.866 17.134 42 21 42H35C38.866 42 42 38.866 42 35V21C42 17.134 38.866 14 35 14Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 42V49H35V42"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 14V7H35V14"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="24"
            y1="23"
            x2="24"
            y2="34"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="28"
            y1="28"
            x2="28"
            y2="34"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="32"
            y1="26"
            x2="32"
            y2="34"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2587_629">
            <rect width="56" height="56" />
          </clipPath>
        </defs>
      </svg>
    ),
  },

  {
    name: "computer",
    icon: (
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="transparent"
        data-stroke-hover
      >
        <g clipPath="url(#clip0_2587_613)">
          <path
            d="M46.6667 9.33337H9.33333C8.04467 9.33337 7 10.378 7 11.6667V35C7 36.2887 8.04467 37.3334 9.33333 37.3334H46.6667C47.9553 37.3334 49 36.2887 49 35V11.6667C49 10.378 47.9553 9.33337 46.6667 9.33337Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.3333 46.6666H39.6667"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 37.3334V46.6667"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35 37.3334V46.6667"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 32H48"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2587_613">
            <rect width="56" height="56" />
          </clipPath>
        </defs>
      </svg>
    ),
  },

  {
    name: "camera",
    icon: (
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="transparent"
        data-stroke-hover
      >
        <g clipPath="url(#clip0_2587_6)">
          <path
            d="M11.6667 16.3334H14C15.2377 16.3334 16.4247 15.8417 17.2998 14.9665C18.175 14.0914 18.6667 12.9044 18.6667 11.6667C18.6667 11.0479 18.9125 10.4544 19.3501 10.0168C19.7877 9.57921 20.3812 9.33337 21 9.33337H35C35.6188 9.33337 36.2123 9.57921 36.6499 10.0168C37.0875 10.4544 37.3333 11.0479 37.3333 11.6667C37.3333 12.9044 37.825 14.0914 38.7002 14.9665C39.5753 15.8417 40.7623 16.3334 42 16.3334H44.3333C45.571 16.3334 46.758 16.825 47.6332 17.7002C48.5083 18.5754 49 19.7624 49 21V42C49 43.2377 48.5083 44.4247 47.6332 45.2999C46.758 46.175 45.571 46.6667 44.3333 46.6667H11.6667C10.429 46.6667 9.242 46.175 8.36683 45.2999C7.49167 44.4247 7 43.2377 7 42V21C7 19.7624 7.49167 18.5754 8.36683 17.7002C9.242 16.825 10.429 16.3334 11.6667 16.3334"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28 37.3334C31.866 37.3334 35 34.1994 35 30.3334C35 26.4674 31.866 23.3334 28 23.3334C24.134 23.3334 21 26.4674 21 30.3334C21 34.1994 24.134 37.3334 28 37.3334Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2587_6">
            <rect width="56" height="56" />
          </clipPath>
        </defs>
      </svg>
    ),
  },

  {
    name: "vector",
    icon: (
      <svg width="22" height="20" viewBox="0 0 22 20">
        <path
          d="M8.91199 9.9998H2.99999L1.02299 2.1348C1.01033 2.0891 1.00262 2.04216 0.999989 1.9948C0.977989 1.2738 1.77199 0.773804 2.45999 1.1038L21 9.9998L2.45999 18.8958C1.77999 19.2228 0.995989 18.7368 0.999989 18.0288C1.00201 17.9655 1.01313 17.9029 1.03299 17.8428L2.49999 12.9998"
          stroke="#fff"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  {
    name: "facebook",
    icon: (
      <svg width="11" height="18" viewBox="0 0 11 18" fill="white">
        <path d="M6 7H10.5L10 9H6V18H4V9H0V7H4V5.128C4 3.345 4.186 2.698 4.534 2.046C4.87501 1.40181 5.40181 0.875009 6.046 0.534C6.698 0.186 7.345 0 9.128 0C9.65 0 10.108 0.0500001 10.5 0.15V2H9.128C7.804 2 7.401 2.078 6.99 2.298C6.686 2.46 6.46 2.686 6.298 2.99C6.078 3.401 6 3.804 6 5.128V7Z" />
      </svg>
    ),
  },

  {
    name: "twitter",
    icon: (
      <svg width="20" height="20" fill="white" viewBox="0 0 512 512">
        <g>
          <path d="M490.7,64.8l-12.3-17.4c-18.5,13.1-39.1,23.1-60.8,29.6l6.2,20.4l16.1-14c-23.1-26.5-55.7-40.2-88.3-40.2   c-27.1,0-54.6,9.5-76.7,28.7l0,0c-25.6,22.2-40.2,54.4-40.2,88.2v0l0,1.6l21.3-0.3h-21.3v21.3H256l-0.6-21.3l-5.3,0.1   c-67,0-130-32.6-168.6-87.6c-4.4-6.3-11.9-9.7-19.5-9c-7.7,0.7-14.3,5.5-17.4,12.6c-0.6,1.6-20.6,46.2-20.7,105.1   c0,33.1,6.5,71,27.6,107c21,36,56.4,69.4,110.7,93.4l8.7-19.5l-12-17.7C121,371.4,76.6,385,31.2,385c-3,0-6-0.1-9-0.2   c-9.8-0.4-18.7,6.1-21.4,15.6S2.4,420,11,424.8c53.4,29.7,110.2,43.9,165.1,43.9c77.2,0,150.8-28.4,205-81.5   c54.2-53.1,88.4-130.9,88.3-226.4l0-0.1c0-7.3-0.7-14.5-2.1-21.6l-21,4l15,15.2c24.6-24.3,41.9-54.9,50.1-88.4   c2.1-8.6-1.4-17.7-8.7-22.7c-7.3-5-17-4.9-24.3,0.2L490.7,64.8l-20.7-5c-6.3,25.9-19.7,49.5-38.6,68.2c-5.1,5-7.3,12.2-6,19.2   c0.9,4.5,1.3,9.2,1.3,13.8l0-0.1c-0.1,85.5-29.8,151-75.5,196c-45.8,44.9-108.2,69.3-175.1,69.3c-47.5,0-97.1-12.3-144.4-38.6   l-10.4,18.6l-0.8,21.3c3.6,0.1,7.2,0.2,10.7,0.2c53.9,0,106.7-16.2,151.4-46.5c6.4-4.4,10-11.8,9.3-19.5   c-0.7-7.7-5.5-14.4-12.6-17.6c-47.4-21.2-74.7-48-91.1-75.9c-16.3-28-21.7-57.9-21.8-85.5c0-24.5,4.3-46.8,8.7-62.8   c2.2-8,4.4-14.4,5.9-18.8c0.8-2.2,1.4-3.8,1.9-4.9l0.5-1.1l0.1-0.2l-3-1.3l3,1.3l0,0l-3-1.3l3,1.3L64,86.1L46.5,98.4   c46.7,66.4,122.7,105.8,203.6,105.8c2.1,0,4.3,0,6.4-0.1c11.6-0.3,20.8-9.7,20.8-21.3v-21.3l0-0.3l0-1c0-21.5,9.3-41.9,25.5-56l0,0   C317,91.9,334.2,86,351.5,85.9c20.8,0,41.3,8.6,56.1,25.5c5.5,6.3,14.2,8.8,22.3,6.4C456,110,480.7,98,503,82.2L490.7,64.8l-20.7-5   L490.7,64.8z" />
        </g>
      </svg>
    ),
  },

  {
    name: "instagram",
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20">
        <path
          d="M15 1H5C3.93913 1 2.92172 1.42143 2.17157 2.17157C1.42143 2.92172 1 3.93913 1 5V15C1 16.0609 1.42143 17.0783 2.17157 17.8284C2.92172 18.5786 3.93913 19 5 19H15C16.0609 19 17.0783 18.5786 17.8284 17.8284C18.5786 17.0783 19 16.0609 19 15V5C19 3.93913 18.5786 2.92172 17.8284 2.17157C17.0783 1.42143 16.0609 1 15 1Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M10 14C11.0609 14 12.0783 13.5786 12.8284 12.8284C13.5786 12.0783 14 11.0609 14 10C14 8.93913 13.5786 7.92172 12.8284 7.17157C12.0783 6.42143 11.0609 6 10 6C8.93913 6 7.92172 6.42143 7.17157 7.17157C6.42143 7.92172 6 8.93913 6 10C6 11.0609 6.42143 12.0783 7.17157 12.8284C7.92172 13.5786 8.93913 14 10 14V14Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M15.5 5.5C15.7652 5.5 16.0196 5.39464 16.2071 5.20711C16.3946 5.01957 16.5 4.76522 16.5 4.5C16.5 4.23478 16.3946 3.98043 16.2071 3.79289C16.0196 3.60536 15.7652 3.5 15.5 3.5C15.2348 3.5 14.9804 3.60536 14.7929 3.79289C14.6054 3.98043 14.5 4.23478 14.5 4.5C14.5 4.76522 14.6054 5.01957 14.7929 5.20711C14.9804 5.39464 15.2348 5.5 15.5 5.5Z"
          fill="white"
        />
      </svg>
    ),
  },

  {
    name: "linkedin",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
        <path d="M11.5 9.05C12.417 8.113 13.611 7.5 15 7.5C16.4587 7.5 17.8576 8.07946 18.8891 9.11091C19.9205 10.1424 20.5 11.5413 20.5 13V20.5H18.5V13C18.5 12.0717 18.1313 11.1815 17.4749 10.5251C16.8185 9.86875 15.9283 9.5 15 9.5C14.0717 9.5 13.1815 9.86875 12.5251 10.5251C11.8687 11.1815 11.5 12.0717 11.5 13V20.5H9.5V8H11.5V9.05ZM4.5 6C4.10218 6 3.72064 5.84196 3.43934 5.56066C3.15804 5.27936 3 4.89782 3 4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3C4.89782 3 5.27936 3.15804 5.56066 3.43934C5.84196 3.72064 6 4.10218 6 4.5C6 4.89782 5.84196 5.27936 5.56066 5.56066C5.27936 5.84196 4.89782 6 4.5 6ZM3.5 8H5.5V20.5H3.5V8Z" />
      </svg>
    ),
  },

  {
    name: "cart",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M3 6.3V20.5C3 20.7652 3.10536 21.0196 3.29289 21.2071C3.48043 21.3946 3.73478 21.5 4 21.5H20C20.2652 21.5 20.5196 21.3946 20.7071 21.2071C20.8946 21.0196 21 20.7652 21 20.5V6.3H3Z"
          stroke="#fff"
          fill="none"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M21 6.3L18.1665 2.5H5.8335L3 6.3M15.7775 9.6C15.7775 11.699 14.0865 13.4 12 13.4C9.9135 13.4 8.222 11.699 8.222 9.6"
          stroke="#fff"
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  {
    name: "solidStar",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M19.8284 9.93621C20.4517 9.93621 20.7176 10.7286 20.2205 11.1046L16.8905 13.6234C16.1688 14.1693 15.8661 15.1087 16.1334 15.9732L17.3864 20.0261C17.5735 20.6312 16.8729 21.1193 16.3701 20.7341L13.3075 18.3879C12.536 17.7969 11.464 17.7969 10.6925 18.3879L7.61357 20.7466C7.11152 21.1312 6.41161 20.645 6.59677 20.0403L7.83243 16.0046C8.09532 15.146 7.79694 14.2145 7.08413 13.6684L3.73432 11.1022C3.24111 10.7244 3.50831 9.93621 4.12961 9.93621H8.12744C9.07024 9.93621 9.90305 9.32198 10.1815 8.42125L11.379 4.5479C11.5678 3.93721 12.4322 3.93722 12.621 4.5479L13.8185 8.42124C14.0969 9.32198 14.9298 9.93621 15.8726 9.93621H19.8284Z"
          stroke="#fff"
          fill="none"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },

  {
    name: "halfStar",
    icon: (
      <svg width="22" height="22" viewBox="0 0 20 20">
        <path
          d="M9.99984 1.83335C9.75073 1.83151 9.50622 1.90038 9.29469 2.03196C9.08316 2.16354 8.9133 2.35242 8.80484 2.57668L6.95317 6.33002L2.80984 6.93168C2.56339 6.96719 2.33181 7.071 2.14133 7.23135C1.95084 7.3917 1.80907 7.60218 1.73205 7.83896C1.65503 8.07573 1.64585 8.32935 1.70555 8.57107C1.76525 8.8128 1.89144 9.03298 2.06984 9.20668L5.06984 12.1283L4.3615 16.255C4.31937 16.5001 4.34664 16.7522 4.44023 16.9826C4.53382 17.213 4.69 17.4127 4.89111 17.559C5.09223 17.7054 5.33027 17.7925 5.57833 17.8107C5.82639 17.8288 6.07457 17.7772 6.29484 17.6617L9.99984 15.7133V1.83335Z"
          fill="#FFAD33"
        />
        <path
          opacity="0.25"
          d="M10 1.83595C10.2491 1.83404 10.5001 2.00001 10.5001 2.00001C10.5001 2.00001 11.0866 2.20807 11.195 2.44195L13.0467 6.35634L17.1901 6.98383C17.4366 7.02086 17.6682 7.12912 17.8587 7.29635C18.0492 7.46358 18.1909 7.68309 18.268 7.93003C18.345 8.17697 18.3542 8.44147 18.2945 8.69357C18.2347 8.94567 18.1086 9.1753 17.9302 9.35645L14.9301 12.4035L15.6384 16.7072C15.6806 16.9629 15.6533 17.2257 15.5597 17.466C15.4661 17.7064 15.3099 17.9146 15.1088 18.0672C14.9077 18.2198 14.6697 18.3107 14.4216 18.3296C14.1735 18.3486 13.9253 18.2947 13.7051 18.1743L10 16.1423V1.83595Z"
          fill="black"
        />
      </svg>
    ),
  },

  {
    name: "cancel",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_2677_458)">
          <path
            d="M8 16L12 12M16 8L11.9992 12M11.9992 12L8 8M12 12L16 16"
            stroke="#fff"
            fill="none"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="12"
            cy="12"
            r="11.25"
            stroke="#fff"
            fill="none"
            strokeWidth="1.5"
          />
        </g>
      </svg>
    ),
  },

  {
    name: "boxArrowLeft",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M4 12H13.5M6 15L3 12L6 9M11 7V6C11 5.46957 11.2107 4.96086 11.5858 4.58579C11.9609 4.21071 12.4696 4 13 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20H13C12.4696 20 11.9609 19.7893 11.5858 19.4142C11.2107 19.0391 11 18.5304 11 18V17"
          stroke="#fff"
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  {
    name: "heart",
    icon: (
      <svg viewBox="0 0 512 512">
        <path d="m226 468-3-2L48 303C17 275 0 235 0 193v-3a147 147 0 0 1 256-98 130 130 0 0 1 25-22 147 147 0 0 1 231 120v3c0 42-17 82-48 110L289 466l-3 2a45 45 0 0 1-60 0zm13-323-1-1-18-20a98 98 0 0 0-172 66v3c0 28 12 56 33 75l175 163 175-163c21-19 33-47 33-75v-3a99 99 0 0 0-172-66l-18 20-1 1a24 24 0 0 1-34 0z" />
      </svg>
    ),
  },

  {
    name: "trashCan",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M135 18c6-11 17-18 29-18h120c12 0 23 7 29 18l7 14h96a32 32 0 1 1 0 64H32a32 32 0 1 1 0-64h96l7-14zM32 128h384v320c0 35-29 64-64 64H96c-35 0-64-29-64-64V128zm96 64c-9 0-16 7-16 16v224c0 9 7 16 16 16s16-7 16-16V208c0-9-7-16-16-16zm96 0c-9 0-16 7-16 16v224c0 9 7 16 16 16s16-7 16-16V208c0-9-7-16-16-16zm96 0c-9 0-16 7-16 16v224c0 9 7 16 16 16s16-7 16-16V208c0-9-7-16-16-16z" />
      </svg>
    ),
  },

  {
    name: "arrowUp",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" />
      </svg>
    ),
  },

  {
    name: "dollarSign",
    icon: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="black">
        <path
          d="M20.0003 37.2728C29.5397 37.2728 37.273 29.5395 37.273 20C37.273 10.4606 29.5397 2.72729 20.0003 2.72729C10.4608 2.72729 2.72754 10.4606 2.72754 20C2.72754 29.5395 10.4608 37.2728 20.0003 37.2728Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.0914 14.547C24.762 13.9758 24.2834 13.505 23.707 13.1848C23.1305 12.8646 22.4777 12.7072 21.8186 12.7294H18.1823C17.2178 12.7294 16.2929 13.1124 15.611 13.7941C14.929 14.4759 14.5459 15.4005 14.5459 16.3647C14.5459 17.3288 14.929 18.2535 15.611 18.9353C16.2929 19.617 17.2178 20 18.1823 20H21.8186C22.783 20 23.708 20.383 24.3899 21.0648C25.0719 21.7465 25.455 22.6712 25.455 23.6354C25.455 24.5995 25.0719 25.5242 24.3899 26.2059C23.708 26.8877 22.783 27.2707 21.8186 27.2707H18.1823C17.5232 27.2929 16.8704 27.1354 16.2939 26.8153C15.7174 26.4951 15.2389 26.0242 14.9095 25.453"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 8.18176V12.1212M20 27.8787V31.8181"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  {
    name: "moneyBag",
    icon: (
      <svg width="41" height="40" viewBox="0 0 41 40" fill="none">
        <path
          d="M20.9278 18.1456V18.6456L21.4278 18.6456C22.0916 18.6457 22.739 18.8514 23.281 19.2346C23.8229 19.6178 24.2327 20.1595 24.454 20.7851C24.4727 20.8381 24.4808 20.8941 24.4778 20.9502C24.4748 21.0062 24.4608 21.0611 24.4366 21.1117C24.4124 21.1624 24.3784 21.2077 24.3367 21.2452C24.295 21.2828 24.2463 21.3117 24.1933 21.3304C24.1404 21.3491 24.0844 21.3571 24.0283 21.3542C23.9723 21.3512 23.9174 21.3372 23.8667 21.313C23.7645 21.2641 23.6858 21.1766 23.6481 21.0697L23.648 21.0695C23.4856 20.6104 23.1849 20.213 22.7873 19.9319C22.3896 19.6509 21.9146 19.5 21.4277 19.5002L20.9278 19.5003V20.0002V23.7092V24.2092H21.4278C22.2789 24.2092 23.0952 24.5473 23.697 25.1491C24.2988 25.7509 24.6369 26.5672 24.6369 27.4183C24.6369 28.2694 24.2988 29.0856 23.697 29.6874C23.0952 30.2892 22.2789 30.6273 21.4278 30.6273H20.9278V31.1273V31.5546H20.0733V31.1273V30.6273L19.5733 30.6273C18.9096 30.6273 18.2621 30.4215 17.7202 30.0383C17.1782 29.6551 16.7684 29.1134 16.5471 28.4876L16.5472 28.4875L16.5422 28.4744C16.5216 28.4211 16.512 28.3642 16.5138 28.3071C16.5156 28.25 16.5289 28.1939 16.5528 28.142C16.5767 28.0901 16.6107 28.0435 16.6529 28.005L16.317 27.6367L16.6529 28.005C16.6952 27.9665 16.7447 27.9369 16.7985 27.9179C16.8524 27.8988 16.9095 27.8908 16.9665 27.8942C17.0236 27.8977 17.0793 27.9125 17.1305 27.9379C17.1817 27.9632 17.2273 27.9986 17.2646 28.0419C17.3019 28.0852 17.3301 28.1355 17.3476 28.1899L17.3499 28.1969L17.3523 28.2039C17.6768 29.1186 18.5484 29.7728 19.5733 29.7728H20.0733V29.2728V25.5637V25.0637H19.5733C18.7222 25.0637 17.906 24.7256 17.3042 24.1238C16.7024 23.522 16.3643 22.7058 16.3643 21.8547C16.3643 21.0036 16.7024 20.1874 17.3042 19.5856C17.906 18.9837 18.7222 18.6456 19.5733 18.6456H20.0733V18.1456V17.7184H20.9278V18.1456ZM20.0733 20.0002V19.5002H19.5733C18.9488 19.5002 18.35 19.7482 17.9084 20.1898C17.4668 20.6314 17.2188 21.2302 17.2188 21.8547C17.2188 22.4792 17.4668 23.078 17.9084 23.5196C18.35 23.9612 18.9488 24.2092 19.5733 24.2092H20.0733V23.7092V20.0002ZM20.9278 29.2728V29.7728H21.4278C22.0523 29.7728 22.6512 29.5247 23.0927 29.0832C23.5343 28.6416 23.7824 28.0427 23.7824 27.4183C23.7824 26.7938 23.5343 26.1949 23.0927 25.7534C22.6512 25.3118 22.0523 25.0637 21.4278 25.0637H20.9278V25.5637V29.2728Z"
          stroke="#fff"
        />
        <path
          d="M13.2057 12.5777L13.5219 12.6998C17.8707 14.3798 23.1083 14.3797 27.457 12.698L27.7695 12.5772L28.0001 12.8203C29.8981 14.8211 31.4858 17.0948 32.7105 19.5658L32.7115 19.5677C33.9873 22.1703 34.7037 24.8133 34.5867 27.1301L34.5867 27.1301C34.4723 29.3912 33.5716 31.3572 31.5218 32.806L31.5218 32.806C29.4129 34.296 25.9467 35.3336 20.5354 35.3336C15.1198 35.3336 11.6397 34.3141 9.51316 32.8421L9.51293 32.842C7.44943 31.412 6.53763 29.472 6.41014 27.2374L13.2057 12.5777ZM13.2057 12.5777L12.9752 12.8262M13.2057 12.5777L12.9752 12.8262M12.9752 12.8262C11.1573 14.7856 9.46566 17.1897 8.25095 19.6929L8.25091 19.6929M12.9752 12.8262L8.25091 19.6929M8.25091 19.6929C6.98037 22.3123 6.2784 24.9432 6.41013 27.2372L8.25091 19.6929ZM30.3428 6.18136C30.7832 6.39921 31.1642 6.60759 31.4775 6.79428L28.3457 11.3725L28.1141 11.7111L28.401 12.0044C30.3394 13.9861 32.1697 16.5163 33.4805 19.1919C34.7935 21.8721 35.5679 24.6624 35.441 27.1735C35.3151 29.6637 34.3054 31.8863 32.0163 33.5035C29.7051 35.1363 26.0382 36.1881 20.5364 36.1881C15.0332 36.1881 11.3544 35.1551 9.02802 33.5441C6.72448 31.9489 5.6991 29.7543 5.55803 27.2856C5.41571 24.7951 6.17576 22.0153 7.48354 19.3201C8.7889 16.6299 10.6229 14.0598 12.5812 11.9993L12.8589 11.7071L12.6323 11.3738L9.52247 6.79791C9.67984 6.70521 9.8536 6.60746 10.043 6.50656L10.043 6.50656L10.0447 6.50564C10.2353 6.40316 10.4408 6.29767 10.6614 6.19013L10.8573 6.09458C13.1034 5.02401 16.6645 3.80945 20.5364 3.80945C24.4384 3.80945 27.9975 5.04283 30.2165 6.12005C30.2165 6.12005 30.2165 6.12005 30.2165 6.12006L30.3412 6.18057C30.3417 6.18083 30.3422 6.1811 30.3428 6.18136ZM26.7245 12.0592L26.8779 12.0047L26.9698 11.8703L29.7117 7.86178L30.2968 7.00635L29.2631 7.08078C26.6696 7.26751 23.6003 7.87479 20.6554 8.7274C18.6714 9.30056 16.4387 9.21929 14.3339 8.83106C13.8046 8.73294 13.279 8.61613 12.758 8.48086L11.4726 8.14712L12.2188 9.24574L13.9991 11.8671L14.091 12.0024L14.245 12.0572C18.1692 13.4543 22.7996 13.4542 26.7245 12.0592ZM12.08 6.48035L10.8004 7.02347L12.1328 7.41985C12.8897 7.64501 13.6821 7.84132 14.4877 7.99046L14.4881 7.99055C16.523 8.36535 18.6079 8.42979 20.4168 7.90582L20.4175 7.90561C22.3859 7.33216 24.388 6.88116 26.4122 6.5552L26.4768 5.58279C24.7353 5.05845 22.6905 4.66397 20.5354 4.66397C17.2536 4.66397 14.2063 5.57787 12.08 6.48035Z"
          stroke="#fff"
        />
      </svg>
    ),
  },

  {
    name: "shoppingBag",
    icon: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path
          d="M11.667 11.6667V8.33339C11.667 7.36818 11.9464 6.42362 12.4714 5.6137C12.9965 4.80379 13.7447 4.16315 14.6258 3.76912C15.5069 3.37509 16.4832 3.24451 17.4369 3.39313C18.3906 3.54176 19.2809 3.96325 20.0003 4.60672C20.7197 3.96325 21.61 3.54176 22.5637 3.39313C23.5174 3.24451 24.4937 3.37509 25.3748 3.76912C26.256 4.16315 27.0042 4.80379 27.5292 5.6137C28.0543 6.42362 28.3336 7.36818 28.3337 8.33339V11.6667H30.8337C31.4967 11.6667 32.1326 11.9301 32.6014 12.399C33.0703 12.8678 33.3337 13.5037 33.3337 14.1667V30.8417C33.3337 32.3866 32.72 33.8682 31.6276 34.9606C30.5352 36.053 29.0535 36.6667 27.5087 36.6667H13.3337C11.5655 36.6667 9.86986 35.9643 8.61961 34.7141C7.36937 33.4639 6.66699 31.7682 6.66699 30.0001V14.1667C6.66699 13.5037 6.93038 12.8678 7.39922 12.399C7.86807 11.9301 8.50395 11.6667 9.16699 11.6667H11.667ZM22.7253 34.1667C22.0454 33.1914 21.6818 32.0306 21.6837 30.8417V14.1667H9.16699V30.0001C9.16699 30.5472 9.27477 31.089 9.48416 31.5946C9.69356 32.1001 10.0005 32.5594 10.3874 32.9463C10.7743 33.3332 11.2336 33.6402 11.7391 33.8496C12.2447 34.0589 12.7865 34.1667 13.3337 34.1667H22.7253ZM19.167 11.6667V8.33339C19.167 7.67035 18.9036 7.03446 18.4348 6.56562C17.9659 6.09678 17.33 5.83339 16.667 5.83339C16.004 5.83339 15.3681 6.09678 14.8992 6.56562C14.4304 7.03446 14.167 7.67035 14.167 8.33339V11.6667H19.167ZM21.667 11.6667H25.8337V8.33339C25.8337 7.81878 25.6749 7.31669 25.379 6.89566C25.0832 6.47463 24.6645 6.15517 24.1803 5.98089C23.6961 5.8066 23.1699 5.78599 22.6736 5.92186C22.1772 6.05773 21.7349 6.34346 21.407 6.74005C21.5753 7.24005 21.667 7.77672 21.667 8.33339V11.6667ZM24.1837 30.8417C24.1837 31.7236 24.534 32.5693 25.1575 33.1929C25.7811 33.8164 26.6268 34.1667 27.5087 34.1667C28.3905 34.1667 29.2362 33.8164 29.8598 33.1929C30.4833 32.5693 30.8337 31.7236 30.8337 30.8417V14.1667H24.1837V30.8417Z"
          fill="white"
        />
      </svg>
    ),
  },

  {
    name: "shop",
    icon: (
      <svg width="41" height="40" viewBox="0 0 41 40" fill="none">
        <path
          d="M34.6416 5H27.9883L28.8216 13.3333C28.8216 13.3333 30.4883 15 32.9883 15C34.3006 15.0017 35.5684 14.524 36.5533 13.6567C36.6574 13.5594 36.735 13.4372 36.7787 13.3016C36.8224 13.166 36.8309 13.0214 36.8033 12.8817L35.6266 5.83333C35.5873 5.60049 35.4668 5.38909 35.2865 5.23656C35.1062 5.08404 34.8778 5.00024 34.6416 5V5Z"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M27.9883 5L28.8216 13.3333C28.8216 13.3333 27.1549 15 24.6549 15C22.1549 15 20.4883 13.3333 20.4883 13.3333V5H27.9883Z"
          stroke="#fff"
          strokeWidth="2"
        />
        <path
          d="M20.4886 5V13.3333C20.4886 13.3333 18.8219 15 16.3219 15C13.8219 15 12.1553 13.3333 12.1553 13.3333L12.9886 5H20.4886Z"
          stroke="#fff"
          strokeWidth="2"
        />
        <path
          d="M12.9883 5H6.3366C6.09993 4.99991 5.87089 5.08377 5.69023 5.23666C5.50957 5.38955 5.38899 5.60157 5.34994 5.835L4.17494 12.8833C4.14747 13.0231 4.15601 13.1676 4.19974 13.3032C4.24348 13.4387 4.32097 13.5609 4.42494 13.6583C4.9716 14.1417 6.19327 15.0017 7.98827 15.0017C10.4883 15.0017 12.1549 13.335 12.1549 13.335L12.9883 5.00167V5Z"
          stroke="#fff"
          strokeWidth="2"
        />
        <path
          d="M5.5 15V31.6667C5.5 32.5507 5.85119 33.3986 6.47631 34.0237C7.10143 34.6488 7.94928 35 8.83333 35H32.1667C33.0507 35 33.8986 34.6488 34.5237 34.0237C35.1488 33.3986 35.5 32.5507 35.5 31.6667V15"
          stroke="#fff"
          strokeWidth="2"
        />
        <path
          d="M25.2217 35V25C25.2217 24.1159 24.8705 23.2681 24.2454 22.6429C23.6202 22.0178 22.7724 21.6666 21.8883 21.6666H18.555C17.671 21.6666 16.8231 22.0178 16.198 22.6429C15.5729 23.2681 15.2217 24.1159 15.2217 25V35"
          stroke="#fff"
          strokeWidth="2"
          strokeMiterlimit="16"
        />
      </svg>
    ),
  },

  {
    name: "truck",
    icon: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <g clipPath="url(#clip0_261_4843)">
          <path
            d="M11.6673 31.6667C13.5083 31.6667 15.0007 30.1743 15.0007 28.3333C15.0007 26.4924 13.5083 25 11.6673 25C9.82637 25 8.33398 26.4924 8.33398 28.3333C8.33398 30.1743 9.82637 31.6667 11.6673 31.6667Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.3333 31.6667C30.1743 31.6667 31.6667 30.1743 31.6667 28.3333C31.6667 26.4924 30.1743 25 28.3333 25C26.4924 25 25 26.4924 25 28.3333C25 30.1743 26.4924 31.6667 28.3333 31.6667Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.33398 28.3335H7.00065C5.89608 28.3335 5.00065 27.4381 5.00065 26.3335V21.6668M3.33398 8.3335H19.6673C20.7719 8.3335 21.6673 9.22893 21.6673 10.3335V28.3335M15.0007 28.3335H25.0007M31.6673 28.3335H33.0007C34.1052 28.3335 35.0007 27.4381 35.0007 26.3335V18.3335M35.0007 18.3335H21.6673M35.0007 18.3335L30.5833 10.9712C30.2218 10.3688 29.5708 10.0002 28.8683 10.0002H21.6673"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 28H6.66667C5.5621 28 4.66667 27.1046 4.66667 26V21.3333M3 8H19.3333C20.4379 8 21.3333 8.89543 21.3333 10V28M15 28H24.6667M32 28H32.6667C33.7712 28 34.6667 27.1046 34.6667 26V18M34.6667 18H21.3333M34.6667 18L30.2493 10.6377C29.8878 10.0353 29.2368 9.66667 28.5343 9.66667H21.3333"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 11.8182H11.6667"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.81836 15.4545H8.48503"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 19.0909H11.6667"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_261_4843">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },

  {
    name: "infiniteArrows",
    icon: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <g clipPath="url(#clip0_261_4865)">
          <path
            d="M33.3327 18.3334C32.9251 15.4004 31.5645 12.6828 29.4604 10.5992C27.3564 8.51557 24.6256 7.18155 21.6888 6.80261C18.752 6.42366 15.7721 7.02082 13.208 8.5021C10.644 9.98337 8.6381 12.2666 7.49935 15M6.66602 8.33335V15H13.3327"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.66602 21.6667C7.07361 24.5997 8.43423 27.3173 10.5383 29.4009C12.6423 31.4845 15.3731 32.8185 18.3099 33.1974C21.2467 33.5764 24.2266 32.9792 26.7907 31.4979C29.3547 30.0167 31.3606 27.7335 32.4994 25M33.3327 31.6667V25H26.666"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_261_4865">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },

  {
    name: "arrowUp2",
    icon: (
      <svg viewBox="0 0 384 512">
        <path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z" />
      </svg>
    ),
  },

  {
    name: "mobile",
    icon: (
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        data-stroke-hover
      >
        <g clipPath="url(#clip0_2888_868)">
          <path
            d="M38.9375 6.125H17.0625C15.5523 6.125 14.3281 7.34922 14.3281 8.85938V47.1406C14.3281 48.6508 15.5523 49.875 17.0625 49.875H38.9375C40.4477 49.875 41.6719 48.6508 41.6719 47.1406V8.85938C41.6719 7.34922 40.4477 6.125 38.9375 6.125Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.6667 7H31.1354"
            stroke="black"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28 44.0052V44.0305"
            stroke="black"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="15.1667"
            y1="39.8334"
            x2="40.8333"
            y2="39.8334"
            stroke="black"
            strokeWidth="2"
          />
        </g>
        <defs>
          <clipPath id="clip0_2888_868">
            <rect width="56" height="56" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },

  {
    name: "codeFork",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V153.3C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96H256v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288H144c-53 0-96-43-96-96V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z" />
      </svg>
    ),
  },

  {
    name: "furniture",
    icon: (
      <svg width="550" height="550" viewBox="-20 -20 550 550" data-fill-hover>
        <path stroke="#080404" fillRule="evenodd" />
        <path
          d="M 81.798 97.931 C 70.479 101.550, 61.941 107.955, 55.808 117.428 C 49.447 127.253, 48 133.681, 48 152.105 L 48 168 38.750 168.022 C 24.481 168.056, 16.425 172.460, 11.085 183.146 L 8 189.319 8.010 275.910 L 8.020 362.500 10.358 367.521 C 14.944 377.370, 24.722 383.972, 34.750 383.990 L 40 384 40 397.826 C 40 416.590, 39.362 416, 59.640 416 C 78.299 416, 77.406 416.709, 82.608 397.750 L 86.380 384 256 384 L 425.620 384 429.392 397.750 C 434.599 416.726, 433.679 416, 452.500 416 C 472.636 416, 472 416.597, 472 397.686 L 472 384 477.250 383.990 C 487.278 383.972, 497.056 377.370, 501.642 367.521 L 503.980 362.500 503.968 276 C 503.956 191.247, 503.915 189.410, 501.928 185.028 C 498.656 177.815, 495.423 174.368, 488.854 171.085 C 483.279 168.299, 481.775 168, 473.340 168 L 464 168 464 152.105 C 464 133.637, 462.542 127.195, 456.151 117.428 C 449.767 107.672, 441.474 101.465, 430.145 97.964 C 423.932 96.044, 420.022 96.001, 255.645 96.054 C 95.769 96.105, 87.220 96.197, 81.798 97.931 M 90.132 113.069 C 83.206 114.444, 77.396 117.766, 72.614 123.084 C 66.107 130.322, 64.841 134.813, 64.255 152.750 L 63.757 168 73.219 168 C 81.789 168, 83.262 168.291, 88.854 171.085 C 95.423 174.368, 98.656 177.815, 101.928 185.028 C 103.773 189.095, 103.958 191.558, 103.978 212.250 C 103.990 224.762, 104.180 235, 104.400 235 C 104.619 235, 107.128 233.433, 109.975 231.517 C 112.822 229.601, 118.089 227.126, 121.681 226.017 C 128.085 224.039, 130.679 224, 256 224 C 381.321 224, 383.915 224.039, 390.319 226.017 C 393.911 227.126, 399.178 229.601, 402.025 231.517 C 404.872 233.433, 407.381 235, 407.600 235 C 407.820 235, 408.010 224.762, 408.022 212.250 C 408.042 191.558, 408.227 189.095, 410.072 185.028 C 413.344 177.815, 416.577 174.368, 423.146 171.085 C 428.738 168.291, 430.211 168, 438.781 168 L 448.243 168 447.745 152.750 C 447.123 133.731, 445.863 129.715, 438.074 121.926 C 427.690 111.542, 446.063 112.521, 258.500 112.351 C 168.300 112.269, 92.534 112.592, 90.132 113.069 M 32.094 185.272 C 30.220 185.947, 27.745 187.770, 26.594 189.323 C 24.508 192.136, 24.500 192.462, 24.500 276 C 24.500 359.538, 24.508 359.864, 26.594 362.677 C 27.745 364.230, 30.220 366.037, 32.094 366.694 C 37.031 368.424, 474.969 368.424, 479.906 366.694 C 481.780 366.037, 484.255 364.230, 485.406 362.677 C 487.486 359.874, 487.502 359.297, 487.773 278.075 C 488.068 189.499, 488.131 190.644, 482.677 186.596 C 479.996 184.606, 478.651 184.500, 456 184.500 C 433.357 184.500, 432.003 184.606, 429.323 186.594 C 424.214 190.383, 424.117 191.499, 424.056 247.576 L 424 299.651 421.686 301.826 L 419.371 304 255.860 304 L 92.349 304 90.174 301.686 C 88.001 299.372, 88 299.345, 87.944 247.436 C 87.883 191.513, 87.785 190.383, 82.679 186.594 C 80.041 184.635, 78.430 184.485, 57.679 184.272 C 42.135 184.112, 34.481 184.411, 32.094 185.272 M 130.132 241.066 C 123.202 242.446, 117.394 245.768, 112.614 251.084 C 106.717 257.644, 104.944 263.098, 104.274 276.750 L 103.721 288 256 288 L 408.279 288 407.726 276.750 C 407.002 261.999, 405.234 257.086, 398.074 249.926 C 387.798 239.650, 400.513 240.522, 258.500 240.348 C 190.300 240.265, 132.534 240.588, 130.132 241.066 M 56 392 L 56 400 60.378 400 L 64.757 400 66.351 393.652 C 67.228 390.161, 68.231 386.561, 68.580 385.652 C 69.130 384.219, 68.340 384, 62.607 384 L 56 384 56 392 M 443.420 385.652 C 443.769 386.561, 444.772 390.161, 445.649 393.652 L 447.243 400 451.622 400 L 456 400 456 392 L 456 384 449.393 384 C 443.660 384, 442.870 384.219, 443.420 385.652"
          stroke="#080404"
          fillRule="evenodd"
        />
      </svg>
    ),
  },

  {
    name: "shirt",
    icon: (
      <svg width="600" height="600" viewBox="-40 -40 600 600" data-fill-hover>
        <path stroke="#080404" fillRule="evenodd" />
        <path
          d="M 149.134 38.082 C 128.033 45.764, 109.943 52.627, 108.934 53.334 C 104.303 56.577, 1.140 149.194, 0.605 150.588 C 0.272 151.454, -0 153.762, -0 155.716 C 0 159.906, 0.357 160.294, 52.207 212.500 L 85.975 246.500 86.237 364.332 L 86.500 482.164 89.766 485.082 L 93.032 488 256 488 L 418.968 488 422.234 485.082 L 425.500 482.164 425.763 364.332 L 426.025 246.500 459.810 212.500 C 478.392 193.800, 497.961 173.912, 503.298 168.304 C 512.342 158.799, 513 157.829, 513 153.995 C 513 151.508, 512.605 150.126, 512 150.500 C 511.450 150.840, 511 150.691, 511 150.170 C 511 149.391, 410.837 59.651, 403.311 53.686 C 399.917 50.996, 323.618 24, 319.410 24 C 314.288 24, 310.380 28.171, 309.490 34.587 C 304.453 70.923, 280.339 90.902, 247.261 86.144 C 221.363 82.418, 206.491 65.353, 201.470 33.600 C 200.590 28.035, 196.283 23.983, 191.327 24.057 C 189.022 24.091, 172.240 29.670, 149.134 38.082 M 150.936 59.368 L 120.372 70.512 82.939 104.006 C 62.350 122.428, 40.952 141.596, 35.387 146.601 L 25.269 155.702 55.582 186.601 L 85.894 217.500 85.962 193.500 C 86.037 166.743, 86.273 165.598, 92.320 162.638 C 95.728 160.970, 96.508 160.920, 99.812 162.163 C 102.293 163.096, 104.072 164.687, 105.248 167.025 C 106.890 170.287, 106.997 179.603, 106.998 318.750 L 107 467 256 467 L 405 467 405 317.136 L 405 167.273 407.636 164.636 C 411.802 160.471, 418.194 160.651, 422.250 165.049 L 425 168.032 425 192.757 L 425 217.483 446.567 195.991 C 458.429 184.171, 472.100 170.225, 476.947 164.999 L 485.760 155.498 438.455 113.044 L 391.149 70.589 361.405 59.799 C 345.045 53.865, 331.023 48.895, 330.244 48.755 C 329.286 48.582, 327.934 51.148, 326.062 56.692 C 319.401 76.422, 304.227 93.304, 286.023 101.237 C 270.667 107.928, 251.597 109.441, 236.557 105.161 C 211.559 98.047, 191.005 77.973, 184.403 54.226 C 183.451 50.802, 182.408 48.051, 182.086 48.112 C 181.764 48.174, 167.746 53.239, 150.936 59.368 M 0.272 155 C 0.272 157.475, 0.467 158.488, 0.706 157.250 C 0.944 156.012, 0.944 153.988, 0.706 152.750 C 0.467 151.512, 0.272 152.525, 0.272 155"
          stroke="#080404"
          fillRule="evenodd"
        />
      </svg>
    ),
  },

  {
    name: "dogHand",
    icon: (
      <svg width="512" height="512" viewBox="0 0 512 512" data-fill-hover>
        <path stroke="#040404" fillRule="evenodd" />
        <path
          d="M 179.500 55.160 C 161.071 57.646, 143.540 74.977, 136.166 98 C 132.132 110.591, 130.733 121.465, 131.277 136 C 131.887 152.305, 134.152 161.815, 140.445 174.500 C 146.025 185.746, 152.338 193.781, 160.064 199.468 C 178.266 212.868, 199.280 211.564, 216.335 195.977 C 234.022 179.812, 243.645 150.784, 240.858 122 C 239.528 108.262, 236.657 97.894, 230.974 86.304 C 219.937 63.796, 200.893 52.273, 179.500 55.160 M 319.500 55.160 C 298.258 58.026, 279.980 78.402, 273.470 106.475 C 259.758 165.596, 297.698 221.928, 340.454 205.931 C 352.923 201.266, 363.658 190.418, 371.555 174.500 C 377.669 162.176, 380.084 152.266, 380.729 136.860 C 381.881 109.325, 374.511 85.966, 359.761 70.401 C 348.053 58.048, 334.926 53.078, 319.500 55.160 M 178.296 72.448 C 173.121 74.065, 165.146 79.809, 161.575 84.490 C 153.448 95.146, 148.026 113.957, 148.026 131.500 C 148.026 165.275, 164.545 191.355, 186 191.451 C 201.712 191.522, 215.395 177.537, 221.662 155 C 223.076 149.916, 223.473 144.797, 223.485 131.500 C 223.498 116.689, 223.203 113.474, 221.194 106.535 C 218.034 95.620, 213.558 87.535, 207.010 80.913 C 198.379 72.184, 188.478 69.265, 178.296 72.448 M 316.011 73.150 C 305.146 77.442, 295.548 90.155, 290.806 106.535 C 288.797 113.474, 288.502 116.689, 288.515 131.500 C 288.527 144.797, 288.924 149.916, 290.338 155 C 293.279 165.575, 298.535 175.434, 304.476 181.519 C 311.462 188.675, 317.454 191.433, 326 191.427 C 347.419 191.411, 363.974 165.286, 363.974 131.500 C 363.974 91.692, 340.712 63.392, 316.011 73.150 M 57.355 158.998 C 35.603 163.521, 22.883 186.200, 24.282 217.968 C 25.763 251.592, 42.265 282.003, 64.534 292.148 C 68.483 293.947, 71.348 294.420, 78.521 294.455 C 86.725 294.496, 88.140 294.206, 94.144 291.250 C 110.392 283.251, 119.014 265.148, 118.987 239.090 C 118.960 213.614, 111.102 191.459, 96.260 175.014 C 84.903 162.430, 70.120 156.344, 57.355 158.998 M 441.317 159.046 C 433.458 160.599, 425.813 165.182, 418 173.024 C 401.532 189.552, 393.047 211.943, 392.930 239.186 C 392.800 269.171, 404.293 288.450, 425.404 293.660 C 431.172 295.083, 433.090 295.145, 438.807 294.091 C 459.912 290.203, 476.834 270.450, 485.114 240.037 C 487.998 229.444, 488.766 207.241, 486.602 197.035 C 483.362 181.762, 473.823 167.263, 463.686 162.200 C 459.467 160.093, 450.500 157.880, 447.114 158.110 C 446.226 158.170, 443.618 158.591, 441.317 159.046 M 55.442 177.877 C 49.960 181.068, 46.417 185.671, 43.416 193.500 C 40.440 201.265, 40.663 226.495, 43.804 237.500 C 48.881 255.288, 58.934 270.297, 69.197 275.411 C 85.797 283.683, 98.688 272.495, 102.144 246.817 C 103.573 236.201, 101.994 223.663, 97.607 210.795 C 90.345 189.491, 79.252 177.500, 65 175.549 C 61.179 175.026, 59.737 175.377, 55.442 177.877 M 438.091 178.129 C 430.875 181.791, 423.702 189.956, 418.632 200.278 C 398.392 241.489, 413.912 289.808, 442.770 275.428 C 452.891 270.384, 461.112 258.722, 467.075 240.950 C 469.752 232.969, 470.325 229.539, 470.761 218.883 C 471.575 198.962, 467.998 186.361, 459.598 179.563 C 456.452 177.016, 454.868 176.508, 449.194 176.226 C 443.798 175.957, 441.645 176.326, 438.091 178.129 M 240.113 243.062 C 226.106 245.560, 209.326 252.956, 198.685 261.321 C 195.833 263.563, 173.884 283.954, 149.909 306.635 C 103.104 350.913, 100.202 354.182, 95.264 368.193 C 93.330 373.682, 92.581 378.112, 92.252 386 C 91.688 399.557, 93.554 408.436, 99.565 420.792 C 108.436 439.026, 125.539 452.514, 145 456.621 C 150.394 457.759, 155.448 458.052, 163 457.663 C 175.180 457.036, 181.697 455.751, 207 448.990 C 230.110 442.815, 241.276 441.009, 256.372 441.004 C 272.025 440.999, 284.882 443.005, 311.500 449.608 C 345.860 458.131, 354.578 459.204, 367.500 456.501 C 385.741 452.684, 403.318 438.992, 411.790 422 C 423.966 397.577, 422.457 371.935, 407.618 351.127 C 403.752 345.707, 321.204 267.363, 312.120 260.494 C 303.797 254.200, 292.821 248.825, 281.380 245.438 C 274.184 243.309, 269.940 242.743, 259 242.456 C 251.575 242.261, 243.076 242.534, 240.113 243.062 M 241 260.451 C 229.292 262.960, 218.355 267.868, 209.376 274.639 C 201.782 280.367, 121.338 356.559, 117.810 361.366 C 110.501 371.324, 107.114 384.936, 108.864 397.313 C 111.773 417.883, 126.432 434.231, 146.703 439.511 C 158.457 442.572, 172.171 440.944, 205.500 432.528 C 250.987 421.042, 266.225 421.185, 317.294 433.580 C 332.031 437.157, 346.930 440.349, 350.404 440.673 C 373.469 442.827, 397.177 424.718, 402.059 401.219 C 403.684 393.400, 402.755 379.855, 400.127 373.023 C 398.968 370.010, 396.424 365.229, 394.474 362.398 C 390.851 357.137, 311.870 281.658, 302.612 274.608 C 296.299 269.801, 283.494 263.585, 275.500 261.447 C 267.194 259.226, 249.147 258.705, 241 260.451"
          stroke="#040404"
          fillRule="evenodd"
        />
      </svg>
    ),
  },

  {
    name: "makeup",
    icon: (
      <svg width="550" height="550" viewBox="-10 -10 550 550" data-fill-hover>
        <path stroke="#040404" fillRule="evenodd" />
        <path
          d="M 167.136 14.534 C 150.445 17.476, 130.756 25.706, 115.046 36.306 C 104.970 43.105, 85.526 62.773, 80.750 70.998 C 74.942 80.998, 75.276 82.481, 85.788 93.385 C 90.621 98.398, 105.558 113.975, 118.982 128 C 132.405 142.025, 146.710 156.920, 150.771 161.099 L 158.153 168.698 162.596 186.385 C 165.990 199.894, 236.785 444.008, 250.547 489.653 C 252.764 497.007, 253.314 497.914, 256.152 498.903 C 257.882 499.506, 263.009 500, 267.544 500 C 277.133 500, 286.122 497.580, 293.186 493.099 C 301.866 487.591, 301.824 489.811, 293.949 453.117 C 290.127 435.306, 287 420.118, 287 419.367 C 287 418.416, 288.355 418, 291.453 418 C 293.902 418, 296.945 417.527, 298.214 416.948 C 301.350 415.520, 377.450 280.748, 385.741 261.942 C 391.216 249.521, 392.329 247.764, 399.014 240.986 C 412.577 227.233, 417.812 216.343, 418.717 199.996 C 419.595 184.152, 416 172.892, 407.295 164.215 C 399.722 156.667, 394.379 154.534, 383 154.516 C 374.059 154.501, 373.035 154.722, 365.597 158.274 C 351.728 164.895, 339.617 179.854, 335.582 195.347 C 334.771 198.462, 333.803 206.070, 333.431 212.255 C 332.785 222.985, 332.501 224.095, 327.208 236.500 C 324.157 243.650, 311.873 278.975, 299.909 315 C 287.945 351.025, 277.928 379.825, 277.649 379 C 277.371 378.175, 268.109 334.300, 257.067 281.500 C 246.025 228.700, 235.023 177.968, 232.617 168.761 L 228.242 152.022 243.621 96.953 C 252.080 66.665, 259 40.516, 259 38.843 C 259 33.342, 249.734 27.082, 232.800 21.143 C 213.412 14.343, 184.643 11.448, 167.136 14.534 M 172.245 28.732 C 168.454 29.074, 168.047 29.354, 168.503 31.308 C 170.356 39.238, 175 66.489, 175 69.431 C 175 75.482, 169.371 78.874, 164.052 76.028 C 161.447 74.634, 161.121 73.538, 157.051 52.500 C 153.720 35.283, 153.193 33.529, 151.437 33.806 C 148.802 34.221, 128.083 44.468, 125.106 46.827 L 122.713 48.725 135.523 72.042 C 143.358 86.303, 148.333 96.450, 148.333 98.167 C 148.333 103.776, 141.393 107.140, 136.893 103.713 C 136.009 103.039, 129.731 92.412, 122.941 80.096 L 110.595 57.704 107.181 61.602 C 105.303 63.746, 101.284 68.549, 98.250 72.276 L 92.733 79.052 98.632 85.276 C 139.254 128.131, 166.542 155.995, 167.868 155.972 C 168.765 155.956, 179.625 153.327, 192 150.128 L 214.500 144.312 228.712 93.406 C 236.529 65.408, 242.941 42.144, 242.962 41.708 C 243.033 40.216, 217.553 30.024, 216.560 31.147 C 216.389 31.341, 213.380 51.708, 209.874 76.406 C 203.533 121.080, 203.486 121.323, 200.752 123.350 C 197.342 125.878, 193.317 124.819, 191.061 120.799 C 189.683 118.345, 190.038 114.696, 195.392 76.313 C 198.599 53.316, 201.457 33.038, 201.743 31.250 L 202.262 28 189.381 28.175 C 182.296 28.271, 174.585 28.522, 172.245 28.732 M 195 165.181 C 184.275 167.864, 174.966 170.246, 174.314 170.474 C 173.462 170.771, 173.957 174.049, 176.076 182.122 C 177.697 188.301, 179.177 193.510, 179.365 193.698 C 179.552 193.886, 185.426 192.681, 192.417 191.020 C 199.408 189.359, 205.688 188, 206.372 188 C 207.393 188, 211.398 200.935, 210.619 201.714 C 210.495 201.838, 204.305 203.416, 196.863 205.220 L 183.332 208.500 223.604 346 C 245.754 421.625, 264.287 484.169, 264.790 484.988 C 265.404 485.989, 266.978 486.380, 269.601 486.185 C 274.754 485.801, 283.026 483.097, 283.596 481.610 C 284.541 479.148, 216.378 161.647, 214.638 160.402 C 214.562 160.347, 205.725 162.498, 195 165.181 M 376.332 169.959 C 367.890 171.970, 356.381 182.353, 351.623 192.250 C 348.956 197.798, 345.896 218.071, 347.620 218.771 C 348.104 218.967, 356.375 222.662, 366 226.982 L 383.500 234.837 389.776 228.169 C 397.303 220.170, 401.660 211.801, 402.879 202.997 C 405.857 181.490, 393.337 165.909, 376.332 169.959 M 340.016 241.250 C 338.228 245.238, 336.567 249.002, 336.327 249.616 C 336.077 250.254, 340.305 252.583, 346.194 255.052 C 351.863 257.428, 356.883 259.694, 357.351 260.087 C 357.973 260.610, 354.501 270.344, 352.475 273.755 C 352.392 273.895, 347.743 271.900, 342.144 269.323 C 336.060 266.522, 331.629 265.011, 331.132 265.568 C 330.172 266.645, 287.961 399.869, 287.985 401.750 C 287.993 402.438, 288.563 402.994, 289.250 402.986 C 291.331 402.962, 365.190 271.164, 370.307 258.343 L 374.759 247.186 359.630 240.584 C 351.308 236.952, 344.223 233.986, 343.884 233.991 C 343.545 233.996, 341.805 237.262, 340.016 241.250"
          stroke="#040404"
          fillRule="evenodd"
        />
      </svg>
    ),
  },

  {
    name: "save",
    icon: (
      <svg width="512" height="512" viewBox="0 0 512 512">
        <path stroke="#080404" fillRule="evenodd" />
        <path
          d="M 109.112 17.581 C 95.465 21.251, 81.487 32.569, 75.239 45.008 C 68.593 58.238, 68.938 45.939, 69.233 259.269 L 69.500 452.500 71.735 459.072 C 77.480 475.962, 90.926 488.864, 108.297 494.154 C 116.743 496.726, 132.316 496.373, 140.991 493.414 C 148.971 490.691, 152.457 488.088, 200.461 449 C 224.439 429.475, 245.732 412.724, 247.779 411.776 C 252.658 409.516, 259.521 409.581, 264.500 411.935 C 266.700 412.974, 288.750 430.332, 313.500 450.506 C 338.250 470.681, 360.336 488.268, 362.580 489.589 C 364.824 490.910, 369.199 492.864, 372.303 493.932 C 401.905 504.117, 434.856 484.770, 441.527 453.287 C 443.712 442.977, 443.679 68.895, 441.493 58.500 C 437.390 38.992, 421.723 22.549, 402.458 17.531 C 393.848 15.288, 117.463 15.335, 109.112 17.581 M 118.236 48.970 C 112.426 50.364, 107.378 54.528, 104.591 60.225 L 101.985 65.552 102.242 257.026 L 102.500 448.500 104.589 452.500 C 107.835 458.716, 113.744 462.340, 121.271 462.732 C 125.723 462.964, 128.560 462.549, 131.214 461.278 C 133.257 460.300, 154.535 443.525, 178.499 424 C 202.462 404.475, 224.859 386.798, 228.269 384.718 C 245.530 374.188, 267.752 374.050, 283.862 384.372 C 286.547 386.093, 308.622 403.700, 332.919 423.500 C 357.215 443.300, 378.760 460.276, 380.797 461.224 C 386.413 463.838, 392.846 463.484, 399.101 460.216 C 403.416 457.962, 404.962 456.416, 407.216 452.101 L 410 446.772 410 256.065 L 410 65.359 407.250 59.934 C 405.185 55.860, 403.275 53.761, 399.579 51.505 L 394.657 48.500 258.079 48.344 C 182.960 48.258, 120.031 48.540, 118.236 48.970"
          stroke="#080404"
          fillRule="evenodd"
        />
      </svg>
    ),
  },

  {
    name: "account",
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20">
        <path
          d="M9.99999 1.66667C5.39999 1.66667 1.66666 5.40001 1.66666 10C1.66666 14.6 5.39999 18.3333 9.99999 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.40001 14.6 1.66667 9.99999 1.66667ZM5.89166 15.2333C6.24999 14.4833 8.43332 13.75 9.99999 13.75C11.5667 13.75 13.7583 14.4833 14.1083 15.2333C12.975 16.1333 11.55 16.6667 9.99999 16.6667C8.44999 16.6667 7.02499 16.1333 5.89166 15.2333ZM15.3 14.025C14.1083 12.575 11.2167 12.0833 9.99999 12.0833C8.78332 12.0833 5.89166 12.575 4.69999 14.025C3.84999 12.9083 3.33332 11.5167 3.33332 10C3.33332 6.32501 6.32499 3.33334 9.99999 3.33334C13.675 3.33334 16.6667 6.32501 16.6667 10C16.6667 11.5167 16.15 12.9083 15.3 14.025Z"
          fill="#5F6368"
        />
        <path
          d="M10 5C8.38334 5 7.08334 6.3 7.08334 7.91667C7.08334 9.53333 8.38334 10.8333 10 10.8333C11.6167 10.8333 12.9167 9.53333 12.9167 7.91667C12.9167 6.3 11.6167 5 10 5ZM10 9.16667C9.30834 9.16667 8.75001 8.60833 8.75001 7.91667C8.75001 7.225 9.30834 6.66667 10 6.66667C10.6917 6.66667 11.25 7.225 11.25 7.91667C11.25 8.60833 10.6917 9.16667 10 9.16667Z"
          fill="#5F6368"
        />
      </svg>
    ),
  },

  {
    name: "arrowRightShort",
    icon: (
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"
        />
      </svg>
    ),
  },

  {
    name: "arrowLeftShort",
    icon: (
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
        />
      </svg>
    ),
  },

  {
    name: "exclamation",
    icon: (
      <svg viewBox="0 0 64 512">
        <path d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
      </svg>
    ),
  },

  {
    name: "questionMark",
    icon: (
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          d="M4.475 5.458c-.284 0-.514-.237-.47-.517C4.28 3.24 5.576 2 7.825 2c2.25 0 3.767 1.36 3.767 3.215 0 1.344-.665 2.288-1.79 2.973-1.1.659-1.414 1.118-1.414 2.01v.03a.5.5 0 0 1-.5.5h-.77a.5.5 0 0 1-.5-.495l-.003-.2c-.043-1.221.477-2.001 1.645-2.712 1.03-.632 1.397-1.135 1.397-2.028 0-.979-.758-1.698-1.926-1.698-1.009 0-1.71.529-1.938 1.402-.066.254-.278.461-.54.461h-.777ZM7.496 14c.622 0 1.095-.474 1.095-1.09 0-.618-.473-1.092-1.095-1.092-.606 0-1.087.474-1.087 1.091S6.89 14 7.496 14"
        />
      </svg>
    ),
  },
];
